import { useEffect, useState } from 'react';
import { ArrowPathIcon } from '@heroicons/react/20/solid';
import { ProgressBar } from "../../../components/progressbar/ProgressBar";

export const DiorRecalibration = ({ hasDoubt = false }) => {
  const FIRST_STEP_DURATION = 5;
  const [progress, setProgress] = useState(0);
  const [showSecondMessage, setShowSecondMessage] = useState(false);

  useEffect(() => {
    if (!hasDoubt) {
      setProgress(0);
      setShowSecondMessage(false);
      return;
    }

    setProgress(0);
    setShowSecondMessage(false);

    const interval = setInterval(() => {
      console.log('interval');
      setProgress((currentProgress) => Math.min(currentProgress + 100 / FIRST_STEP_DURATION, 100));
    }, 1000);

    const timeout = setTimeout(() => {
      clearInterval(interval);
      setShowSecondMessage(true);
    }, (FIRST_STEP_DURATION + 1) * 1000);

    return () => {
      clearInterval(interval);
      clearTimeout(timeout);
    };
  }, [hasDoubt]);

  return (
    <div className={`absolute ${hasDoubt ? 'opacity-100' : 'opacity-0'} transition-all pointer-events-none top-0 left-0 w-full h-full z-20 bg-black/40 backdrop-blur flex justify-center items-center`}>
      <div className="bg-perception-black-700 w-[800px] py-16 pt-24 flex flex-col items-center justify-center gap-8 text-2xl text-center rounded-md">
        <p>The AI system may be unsure about the position of the racks.</p>
        <ArrowPathIcon className="size-16 animate-spin"/>
          <div className="flex flex-col gap-4">
            {
              showSecondMessage ?
                <p>The next action on the line will recalibrate the system.</p> :
                <p>System recalibration in progress...</p>
            }
            <ProgressBar
              value={progress} color="bg-perception-blue" durationClass="duration-1000" bgColor="bg-perception-black-500" size="sm"
              className={`${showSecondMessage ? 'opacity-0' : ''}`}
            />
          </div>
      </div>
    </div>
  );
};